import { DateTime } from "luxon";

import { MDSIconKind } from "@/mds";

export const getAgentActivityDay = ({ occurredAt }: { occurredAt: string }) => {
  const value = DateTime.fromISO(occurredAt).toLocal();
  return value.isValid ? value.toISODate() : "unknown";
};

export const formatAgentActivityDay = ({
  occurredAt,
  now = DateTime.local(),
}: {
  occurredAt: string;
  now?: DateTime;
}) => {
  const value = DateTime.fromISO(occurredAt).toLocal();
  if (!value.isValid) return "Earlier";

  const day = value.startOf("day");
  if (day.hasSame(now.startOf("day"), "day")) return "Today";
  if (day.hasSame(now.startOf("day").minus({ days: 1 }), "day")) return "Yesterday";
  return day.toFormat("MMMM d, yyyy");
};

export const formatAgentActivityDateTime = ({ occurredAt }: { occurredAt: string }) => {
  const value = DateTime.fromISO(occurredAt).toLocal();
  return value.isValid ? value.toFormat("MMM d, h:mma") : "Unknown time";
};

export const formatAgentActivityItemTime = ({
  occurredAt,
  parentOccurredAt,
}: {
  occurredAt: string;
  parentOccurredAt: string;
}) => {
  const value = DateTime.fromISO(occurredAt).toLocal();
  const parent = DateTime.fromISO(parentOccurredAt).toLocal();
  if (!value.isValid) return "Unknown time";
  return parent.isValid && value.hasSame(parent, "day")
    ? value.toFormat("h:mma")
    : value.toFormat("MMM d, h:mma");
};

export const getAgentActivityIcon = ({
  icon,
  sourceKind,
}: {
  icon?: string | null;
  sourceKind?: string;
}): MDSIconKind => {
  switch (icon) {
    case "connection":
      return MDSIconKind.Link;
    case "scanner":
      return MDSIconKind.Refresh;
    case "task":
      return MDSIconKind.ListCheck;
    case "project":
      return MDSIconKind.Folder;
    case "routine":
    case "calendar":
    case "schedule":
      return MDSIconKind.Calendar;
    case "email":
      return MDSIconKind.Envelope;
    case "chat":
      return MDSIconKind.Message;
    default:
      break;
  }

  if (sourceKind === "email") return MDSIconKind.Envelope;
  if (sourceKind === "chat") return MDSIconKind.Message;
  if (sourceKind === "schedule" || sourceKind === "routine") return MDSIconKind.Calendar;
  return MDSIconKind.History;
};
